; (function () {
    var _$wrapper = null,
        _popup_open = false,  //set to true when a popup is open, can't open another
        _package_id = null,
        _template_id = null,
        _current_step = 1, //package wizard
        _num_steps,
        _done = false;

        //
        // init 
        //
        init = function () {
            _$wrapper = $('.layout-package-view');

            if (_$wrapper.length > 0) {
                _package_id = _$wrapper.data('packageid');
                _template_id = _$wrapper.data('templateid');
                setupPackageDate();
                disableEnterKey();
                setupModifyPackage();
            }
        },

        disableEnterKey = function () {
            document.addEventListener('keydown', function (event) {
                if (event.key === 'Enter') {
                    event.preventDefault();
                }
            });
        },


        //
        // setup package date popup
        //
        setupPackageDate = function () {
            // unbind in event of multiple date changes
            $('.date-validate').off('click');
            $('.date-validate').on('click', function () {
                _popup_open = true;
                delta.ajax.get(
                    `/Package/Date?`,
                    function (html) {
                        delta.popup.open({
                            type: 'confirm',
                            title: 'Package Date',
                            content: html,
                            afterOpen: function ($popup) {
                                _popup_open = false;
                                delta.utility.setupDatePicker($popup);
                            },
                            okCallback: function ($popup) {
                                $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spin fa-spinner fs-3"></i>');
                                rptDate = $popup.find('#ReportPeriodEndDate').val();

                                var qsParam = document.getElementById('qsParams').value;
                                var urlDoc = `/package/export?${qsParam}&packageID=${_package_id}&reportPeriodEndDate=${rptDate}&exportFormat=DOCX`;
                                document.getElementById('btnExportDoc').setAttribute('href', urlDoc);

                                // update hidden and UI date value and export link
                                _$wrapper.find('#ReportPeriodEndDate').val(rptDate);
                                $('#package-date').html(`<span class="bold">${rptDate}</span>`);

                                delta.popup.close($popup);
                                validatePackage(rptDate);
                            }
                        })
                    }
                )
            })
        },


        validatePackage = async function (packageReportDate) {

            var packageCacheID = null;

            // hide/disable any showing
            document.getElementById('divPackagePreview').classList.add('d-none');
            document.getElementById('btnExportDoc').classList.add('d-none');
            _$wrapper.find('#validation-retry').hide();
            _$wrapper.find('#generating-status-progress').hide();
            _$wrapper.find('#generating-status-details').hide();
            _$wrapper.find('button').prop('disabled', true);
            
            // display/update validation screen
            document.getElementById('divPackageValid').classList.remove('d-none');
            
            // update package and steps statuses
            var $generateMessage = _$wrapper.find('#generate-message');
            $generateMessage.html(
                ` <p class="text-dark">
                    <i class="ms-3 fa-regular fa-spin fa-gear text-success"></i>
                    Validating package.  Please wait...
                </p>`
            );
            $('table tr').each(function () {
                $(this).find('td:eq(1)').html('<span class="muted italic"><i class="fa-regular fa-2xs fa-circle ms-1 inherit-color"></i> Not started</span>'); 
            });

            // Add template validation
            var templateValid = false;
            var $templateStatus = $('#template-valid-status');
            $templateStatus.html(`
            <span class='muted italic'>
                Checking<span class="loading"></span>
            </span>`
            );

            await new Promise((resolve) => {
                delta.ajax.get(
                    `/Package/ValidateTemplate?templateID=${_template_id}`,
                    function (result) {
                        if (result.templateExists) {
                            $templateStatus.html(`
                            <span class='text-success'>
                                <i class="fa-solid fa-circle-check inherit-color"></i>
                                Template is valid
                            </span>`
                            );
                            templateValid = true;
                        } else {
                            $templateStatus.html(`
                            <span class='text-danger'>
                                <i class="fa-solid fa-triangle-exclamation inherit-color"></i>
                                Template was deleted
                            </span>`
                            );
                            templateValid = false;
                        }
                        resolve();
                    }
                );
            });


            // If the template is not valid, stop further validation
            if (!templateValid) {
                $generateMessage.html(`
                <p class="text-danger">
                    <i class="fa-solid fa-bell-exclamation me-2"></i>
                    The template for this package has been deleted. Please modify the package and select a new template.
                </p>
            `);
                setupRetryValidation();
                return false;
            }


            // check if package is generating
            var isGenerating = false;
            $readyStatus = $('#generate-ready-status');
            $readyStatus.html(`
                <span class='muted italic'>
                    Checking<span class="loading"></span>
                </span>`
            );
            await new Promise((resolve) => {
                delta.ajax.get(
                    '/Package/ValidateGeneration?packageID=' + _package_id,
                    function (result) {
                        $readyStatus.html(`
                            <span class='text-success'>
                                <i class="fa-solid fa-circle-check inherit-color"></i>
                                ${result.message}
                            </span>`
                        );
                        isGenerating = result.isGenerating;
                        if (result.isGenerating == true) {
                            packageCacheID = result.packageCacheID;
                            // update cache status on screen
                            _$wrapper.find('#cache-valid-status').html(`
                                <span class='text-success'>
                                    <i class="fa-solid fa-circle-check inherit-color"></i>
                                    ${result.message}
                                </span>
                            `)
                        }
                        
                        resolve();
                    }
                );
            });

            if(isGenerating == true) {
                startPackageGeneratorTimer(packageCacheID);
                // update the UI
                $('td.report-status').each(function () {
                    $(this).html(`
                    <span class='text-success'>
                        <i class="fa-solid fa-circle-check inherit-color"></i>
                        Report is valid
                    </span>`);
                });
                _$wrapper.find('#generating-package-status').html(`
                    <span>
                        Generating<span class="loading"></span>
                    </span>`
                );
                _$wrapper.find('#generating-status-progress').show();
                _$wrapper.find('#generating-status-details').show();

                return false;

            }

            // check if package cache exists and is valid
            var cacheValid = false;
            $cacheStatus = $('#cache-valid-status');
            $cacheStatus.html(`
                <span class='muted italic'>
                    Checking<span class="loading"></span>
                </span>`
            );

            await new Promise((resolve) => {
                delta.ajax.get(
                    `/Package/ValidateCache?packageID=${_package_id}&packageReportDate=${packageReportDate}`,
                    function (result) {
                        $cacheStatus.html(`
                            <span class='text-success'>
                                <i class="fa-solid fa-circle-check inherit-color"></i>
                                ${result.message}
                            </span>`
                        );
                        cacheValid = result.cacheValid;
                        packageCacheID = result.cacheID;

                        resolve();
                    }
                );
            });

            if (cacheValid == true) {
                startPackageGeneratorTimer(packageCacheID);
                // update the UI
                $('td.report-status').each(function () {
                    $(this).html(`
                    <span class='text-success'>
                        <i class="fa-solid fa-circle-check inherit-color"></i>
                        Report is valid
                    </span>`);
                });
                _$wrapper.find('#generating-package-status').html(`
                    <span>
                        Loading<span class="loading"></span>
                    </span>`
                );

                return false;
            }


            // get reports ids and send to controller for validation
            var $reports = $('input[type="hidden"][name="ReportIDs"]');
            var reportIDs = [];
            var packageValid = true;

            $reports.each(function () {
                reportIDs.push($(this).val());
            });

            if (reportIDs.length == 0){ // DRT-432
                var $rptStatus = $(`#rpt-valid-status-0`);
                packageValid = false;
                $rptStatus.html(
                    `<span class='text-danger'>
                        <i class="fa-solid fa-triangle-exclamation inherit-color"></i>
                        Press "Modify Package" and choose reports.
                    </span>`
                );
                resolve();
            }

            for (var reportID of reportIDs) {
                var $rptStatus = $(`#rpt-valid-status-${reportID}`);
                $rptStatus.html('<div class="muted italic">Validating<span class="loading"></span></div>')
                var formData = new FormData();
                formData.append('reportID', reportID);
                formData.append('packageReportDate', packageReportDate);

                await new Promise((resolve) => {
                    delta.ajax.postFormData(
                        '/Package/ValidateReport',
                        formData,
                        function (result) {
                            // update title and end date, could have changed before retry
                            $(`#rpt-title-${reportID}`).text(result.reportTitle);
                            $(`#rpt-date-${reportID}`).text(`(${result.reportPeriodEndDate})`);
                            // update report status
                            if (result.isValid) {
                                $rptStatus.html(`
                                    <span class='text-success'>
                                        <i class="fa-solid fa-circle-check inherit-color"></i>
                                        ${result.message}
                                    </span>`
                                );
                            } else {
                                packageValid = false;
                                $rptStatus.html(
                                    `<span class='text-danger'>
                                        <i class="fa-solid fa-triangle-exclamation inherit-color"></i>
                                        ${result.message}
                                    </span>`
                                );
                            }
                            resolve();
                        }
                    );
                });
            }

            // update UI, next steps
            if (!packageValid) {
                $generateMessage.html(`
                    <p class="text-danger">
                        <i class="fa-solid fa-bell-exclamation me-2"></i>
                        There are currently one or more validation issues impacting your package.
                    </p>
                `);
                setupRetryValidation();
            } else {
                _$wrapper.find('#validation-retry').hide();
                generatePackage();
            }

        }



        setupRetryValidation = function () {
            _$wrapper.find('#validation-retry').show();
            _$wrapper.find('button').prop('disabled', false);
            // unbind in event of multiple retry
            _$wrapper.find('#btnValidationRetry').off('click');
            _$wrapper.find('#btnValidationRetry').on('click', function () {
                validatePackage();
            })

            return false;
        },


        generatePackage = function () {
            _$wrapper.find('#generate-message').html(
                `<p class="text-dark">
                    <i class="ms-3 fa-regular fa-spin fa-gear text-success"></i>
                    Generating package.  Please wait...
                </p>`
            );
            _$wrapper.find('#generating-package-status').html(' <span id="gen-status-update">Initializing</span><span class="loading"></span>');
            _$wrapper.find('#generating-status-progress').show();
            _$wrapper.find('#generating-status-details').show();
            delta.ajax.get(
                `/package/generate?packageID=${_package_id}`,
                function (result) {
                    if (result.cacheID === 0) {
                        _$wrapper.find('#generate-message').html(`<p class="text-danger">Unknown package</p>`);
                        return;
                    }
                    var packageCacheID = result.cacheID;
                    startPackageGeneratorTimer(packageCacheID);
                }
            );
            return false;
        }

        
        //
        // start the package generator timer
        //
        startPackageGeneratorTimer = function (packageCacheID) {
            delta.ajax.get(
                `/Package/GeneratorPoll?packageID=${_package_id}&packageCacheID=${packageCacheID}`,
                function (result) {
                    var $genMessage = _$wrapper.find('#generate-message')
                    var $genStatus = _$wrapper.find('#generating-package-status');
                    var $genStatusProgress = _$wrapper.find('#generating-status-progress');
                    var $genStatusDetails = _$wrapper.find('#generating-status-details');
                    if (result.error == true) {
                        $genMessage.html(`
                            <p class="text-danger">
                                <i class="fa-solid fa-bell-exclamation me-1"></i>
                                We're sorry, a system error occurred while generating your package. Please contact support for assistance.
                            </p>
                        `);
                        $genMessage.show();
                        $genStatus.html(`<span class='text-danger'><i class="fa-solid fa-triangle-exclamation inherit-color"></i> ${result.message}`);
                        $genStatusProgress.hide();
                    }
                    else {
                        if (result.message == "Loading") {
                            $genMessage.html(`
                                <p class="text-warning">
                                    <i class="fa-solid fa-bell-exclamation me-1"></i>
                                    ${result.message} <span class="loading"></span>
                                </p>
                            `);
                        }
                        else {
                            _$wrapper.find('#gen-status-update').text(` ${result.message}`);
                        }
                        if (!result.done) {
                            if (result.hasDetail == true) {
                                $genStatusDetails.show();
                                $genStatusDetails.html(result.html);
                            }
                            startPackageGeneratorTimer(packageCacheID);
                        } else {
                            $genStatusDetails.hide();
                            var qsParam = document.getElementById('qsParams').value;
                            var urlPdf = `/package/embed?${qsParam}&packageID=${_package_id}&reportPeriodEndDate=${rptDate}&exportFormat=PDF#toolbar=0`;

                            document.getElementById("framePackagePreview").setAttribute("src", urlPdf);
                            document.getElementById('divPackageValid').classList.add('d-none');                          
                            document.getElementById('divPackagePreview').classList.remove('d-none');

                            _$wrapper.find('button').prop('disabled', false);
                            _$wrapper.find('#btnExportDoc').removeClass('d-none');
                        }
                    }
                }
            );
        },


        //
        // setup the modify package button
        //
        setupModifyPackage = function () {
            _$wrapper.on('click', '#btnModifyPackage', function () {

                if (!_popup_open) {
                    _popup_open = true;
                    delta.ajax.get(
                        `/package/packageWizard?packageID=${_package_id}`,
                        function (html) {
                            delta.popup.open({
                                type: 'generic',
                                title: 'Modify Package',
                                content: html,
                                css: 'popup-move',
                                cssClass: 'modal-modify-package',
                                afterOpen: function ($popup) {
                                    setupModifyWizard();
                                    delta.utility.setupDatePicker($popup);
                                    _popup_open = false;
                                },
                                buttons: [
                                    {
                                        text: 'Previous',
                                        isPrimary: false,
                                        leftAlign: true
                                    },
                                    {
                                        text: 'Next',
                                        isPrimary: true,
                                        leftAlign: true
                                    },
                                    {
                                        text: 'Cancel',
                                        isPrimary: false,
                                        callback: function ($popup) {
                                            delta.popup.close($popup);
                                            _current_step = 1,
                                            _done = false
                                        }
                                    },
                                    {
                                        text: 'Finish',
                                        isPrimary: false,
                                        callback: function ($popup) {
                                            $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spin fa-spinner fs-3"></i>');
                                            var formData = new FormData();
                                            $popup.find('input, select').each(function () {
                                                var name = $(this).attr('name');
                                                var value = $(this).val();
                                                formData.append(name, value);
                                            });
                                            var reports = $popup.find('.selected-report').map(function () {
                                                return {
                                                    ReportID: $(this).data('id'),
                                                };
                                            }).get();
                                            reports.forEach(function (rpt, index) {
                                                formData.append(`Reports[${index}].ReportID`, rpt.ReportID);
                                                formData.append(`Reports[${index}].SortOrder`, index + 1);
                                            });

                                            delta.ajax.postFormData(
                                                '/package/save',
                                                formData,
                                                function (result) {
                                                    delta.popup.close($popup);
                                                    window.location = result.redirectURL;
                                                }
                                            );

                                            return false;
                                        }
                                    },
                                ],
                            });

                        }
                    );
                }
            });
        },


        setupModifyWizard = function () {
            $(".title-template-step").addClass("show active");
            _num_steps = $('.container-steps .wizard-step').length;
            //Assign consecutive IDs to all available tabs, which are then used for navigation purposes.
            const visibleSteps = document.querySelectorAll('.container-steps .wizard-step');
            Array.from(visibleSteps).map((step, index) => {
                step.id = `StepWizard${index + 1}`;
            });

            const visibleTabSteps = document.querySelectorAll('.tab-content .tab-pane');
            Array.from(visibleTabSteps).map((step, index) => {
                step.id = `StepTab${index + 1}`;
            });

            packageModifyButtons();
            packageModifyTitleTemplate();
            packageModifySelectReports();

            packageModifyShowStep(1);
        },

        packageModifyButtons = function () {
            const $prevBtn = $(".modal-modify-package button[data-btn-index='0']");
            const $nextBtn = $(".modal-modify-package button[data-btn-index='1']");
            const $finishBtn = $(".modal-modify-package button[data-btn-index='3']");

            $($prevBtn).prop("disabled", true);
            $($finishBtn).prop("disabled", true);


            $($prevBtn).on("click", function () {
                const incomplete = packageModifyValidateStep('prev');
                if (!incomplete && _current_step > 1) {
                    packageModifyShowStep(+_current_step - 1);
                    updateModifyPackageSummary();
                }
            });

            $($nextBtn).on("click", function () {
                const incomplete = packageModifyValidateStep('next');
                if (!incomplete && _current_step < _num_steps) {
                    packageModifyShowStep(_current_step + 1);
                    updateModifyPackageSummary();
                }
                if (_current_step === _num_steps) {
                    updateModifyPackageSummary();
                }

            });

        },


        packageModifyTitleTemplate = function () {
            const $finishBtn = $(".modal-modify-package button[data-btn-index='3']");
           
            $("#Title").on("input paste cut change keyup", function () {
                ttStepValid();
                updateModifyPackageSummary();
            });

            $('#TemplateID').on('change', function () {
                ttStepValid();
                updateModifyPackageSummary();
            })

            var ttStepValid = function () {
                if ($('#Title').val().trim() === "" || $("#TemplateID").val() == "") {
                    $($finishBtn).prop("disabled", true);
                } else if (_done) {
                    $($finishBtn).prop("disabled", false);
                }
            }

        },


        packageModifySelectReports = function () {
            createDraggableElems();
            updateModifyPackageSummary();
            createSortableElems();
            const $finishBtn = $(".modal-modify-package button[data-btn-index='3']");

            var $checkboxes = $('.report-select');
            $checkboxes.on('click', function () {
                // always disable Finish btn, checking re-creates sort order
                $($finishBtn).prop("disabled", true);
                createDraggableElems();
                updateModifyPackageSummary();
                createSortableElems();

            })
        }

        createDraggableElems = function () {
            $('#report-order').empty();
            $('.report-select:checked').each(function () {
                var checkboxId = $(this).attr('id');
                var label = $('label[for="' + checkboxId + '"]').text();
                var pillClasses = "badge bg-secondary-custom text-dark text-left rounded-pill mb-2 ps-2 draggable selected-report";
                var draggablePill = $(`<div data-id="${checkboxId}" class="${pillClasses}">${label}</div>`);
                $('#report-order').append(draggablePill);
            });
        }

        createSortableElems = function () {
            $("#report-order").sortable({
                placeholder: 'ui-state-highlight',
                //axis: 'y',
                containment: ".ui-sortable",
                tolerance: "pointer",
                start: function () {
                    $('.modal-body').css('overflow', 'hidden');
                },
                stop: function () {
                    $('.modal-body').css('overflow', '');
                    updateModifyPackageSummary();
                }
            });
            $("#report-order").disableSelection();
        }

        packageModifyValidateStep = function (action) {
            let incomplete = false;
            $('.text-danger').hide();

            if (_current_step === 1) {
                if ($('#Title').val().trim() === "") {
                    if (action === 'next') {
                        $('#Title').after('<label class="required-label text-danger mt-1">Package title is required</label>');
                        $('#Title').trigger('focus');
                    }
                    incomplete = true;
                }

                if($('#TemplateID').val() === "") {
                    if (action === 'next') {
                        $('#TemplateID').after('<label class="required-label text-danger mt-1">Package template is required</label>');
                        $('#TemplateID').trigger('focus');
                    }
                    incomplete = true;
                }

                if (incomplete == true) {
                    $("#StepWizard2 .wizard-step-circle").removeClass('wizard-step-completed');
                    // $("#StepWizard2 .fa-check").hide();
                }
                    
            }

            if (_current_step === 2) {
                var checkboxes = $('.report-select');
                var isChecked = checkboxes.is(':checked');
                if (!isChecked) {
                    if (action === 'next' || action === 'prev') {
                        $('#list-report-select').after('<label class="required-label text-danger mt-1">At least one report required to build package.</label>');
                    }
                    incomplete = true;
                }
            }
 
            return incomplete;
        },



        packageModifyShowStep = function (step) {
            const $prevBtn = $(".modal-modify-package button[data-btn-index='0']");
            const $nextBtn = $(".modal-modify-package button[data-btn-index='1']");
            const $finishBtn = $(".modal-modify-package button[data-btn-index='3']");
            const $currentStepWizard = $("#StepWizard" + step);
            const $currentStepCircle = $currentStepWizard.find('.wizard-step-circle');

            $(".tab-pane, .wizard-step-circle").removeClass("show active wizard-step-active");

            $("#StepTab" + step).addClass("show active");
            $currentStepWizard.addClass("show active");

            if (step > 1) {
                $("#StepWizard" + (+step - 1) + ' .wizard-step-circle').addClass('wizard-step-completed');
                // $("#StepWizard" + (+step - 1) + ' .fa-check').show();
            }


            $prevBtn.prop("disabled", step === 1);
            $nextBtn.prop("disabled", step === _num_steps);

            if (_num_steps === step) {
                $finishBtn.addClass("btn-success").removeClass("btn-light").prop("disabled", false);
                _done = true;
            }

            if (step === _num_steps) {
                $currentStepCircle.addClass('wizard-step-completed wizard-step-active');
            } else {
                $currentStepCircle.addClass('wizard-step-active');
            }

            $('.modal-modify-package .tbl-steps td').each(function(idx) {        
                var $td = $(this);
                var $cir = $td.find('.wizard-step-circle');
    
                if ($cir.hasClass('wizard-step-completed')) {
                    $td.addClass('td-completed');
                } else {
                    $td.removeClass('td-completed');
                }
    
                if ($cir.hasClass('wizard-step-active')) {
                    $td.addClass('td-active');
                } else {
                    $td.removeClass('td-active');
                }
    
                $cir.html(idx+1);
            });
    

            _current_step = step;
        },


            updateModifyPackageSummary = function () {
            
            // title
            var title = $('#Title').val();
            $('#summary-package-title').text(title);

            //template
            var template = $('#TemplateID option:selected').text();
            $('#summary-package-template').text(template);

            //reports
            $('#summary-reports').empty();
            $('#report-order .draggable').each(function () {
                var textValue = $(this).text();
                $('#summary-reports').append(`<li>${textValue}</li>`);
            });

        },

        dummy = function () { };

    $(document).ready(init);

}());




